<template>
  <v-dialog v-model="dialog" persistent max-width="500px">
    <v-card grid-list-md>
      <ModelTitle title="Assign Curriculum" @close="close()" />
      <v-card-text>
        <v-row v-if="selectedClassRoom">
          <v-col cols="12" sm="12">
            <div>
              Class:
              <span class="font-weight-bold text-capitalize">{{
                selectedClassRoom.Class.name
              }}</span>
            </div>
            <div>
              Room Name:
              <span class="font-weight-bold text-capitalize">{{
                selectedClassRoom.name
              }}</span>
            </div>
          </v-col>

          <v-col cols="12" sm="12">
            <v-autocomplete
              dense
              autofocus
              hide-details
              :items="Curriculums"
              clearable
              item-text="name"
              v-model="selectedCurriculum"
              return-object
              label="Select Curriculum"
              outlined
              ><template slot="item" slot-scope="{ item }">
                <span>{{ item.name }}</span>
                <v-spacer></v-spacer>
              </template>
            </v-autocomplete>
          </v-col>
        </v-row>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="secondary" text @click="close()">Close</v-btn>
        <v-btn color="green lighten-1" :loading="loading" dark @click="submit()"
          >save</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import curriculumService from "@/modules/ReportCard/Curriculums/service.js";
import classRoomService from "../service.js";

export default {
  props: {
    editDialog: {
      default: false,
    },
    selectedClassRoom: {
      type: Object,
    },
  },
  name: "Assign-Curriculum-To-Classroom",
  data() {
    return {
      Curriculums: [],
      selectedCurriculum: null,
      loading: false,
      dialog: false,
    };
  },
  watch: {
    editDialog(val) {
      this.dialog = val;
    },
    dialog(val) {
      if (val) {
        this.getCurriculums();
      }
    },
  },
  methods: {
    submit() {
      return classRoomService
        .update(this.selectedClassRoom.id, {
          CurriculumId: this.selectedCurriculum.id
        })
        .then(() => {
          this.$swal
            .mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
            })
            .fire({
              icon: "success",
              title: "Curriculum assigned to this classroom",
            });
          this.empty();
          this.$emit("submit");
        })
        .catch((err) => {
          this.loading = false;
          this.$swal
            .mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
            })
            .fire({
              icon: "error",
              title: err.data.message,
            });
        });
    },
    getCurriculums() {
      return curriculumService.getAll({ClassId: this.selectedClassRoom.ClassId}).then((response) => {
        this.Curriculums = response.data;
        console.log("response Curriculums", this.Curriculums);

        return response;
      });
    },
    close() {
      this.empty();
      this.$emit("close");
    },
    empty() {
      this.selectedCurriculum = null;
    },
  },
};
</script>

<style scoped></style>
